const NAMED_MARK_COLORS = {
  rot: "#d64545",
  red: "#d64545",
  blau: "#3f6fc1",
  blue: "#3f6fc1",
  gruen: "#4f8f57",
  grün: "#4f8f57",
  green: "#4f8f57",
  gelb: "#e4be37",
  yellow: "#e4be37",
  orange: "#df812f",
  lila: "#8759a8",
  violett: "#8759a8",
  purple: "#8759a8",
  rosa: "#d96d9b",
  pink: "#d96d9b",
  braun: "#815a3b",
  brown: "#815a3b",
  grau: "#777777",
  gray: "#777777",
  grey: "#777777",
  schwarz: "#252525",
  black: "#252525",
  weiss: "#f2f2f2",
  weiß: "#f2f2f2",
  white: "#f2f2f2",
  gold: "#be9e44",
};

const FALLBACK_MARK_COLORS = [
  "#b95756",
  "#3f6fc1",
  "#4f8f57",
  "#d18b31",
  "#8759a8",
  "#b85883",
  "#347f84",
  "#815a3b",
];

const MARK_COLOR_NAMES = {
  "#d64545": "Rot",
  "#3f6fc1": "Blau",
  "#4f8f57": "Grün",
  "#e4be37": "Gelb",
  "#df812f": "Orange",
  "#8759a8": "Lila",
  "#d96d9b": "Rosa",
  "#815a3b": "Braun",
  "#777777": "Grau",
  "#252525": "Schwarz",
  "#f2f2f2": "Weiß",
  "#be9e44": "Gold",
};

const expandShortHex = value => (
  `#${value.slice(1).split("").map(character => character + character).join("")}`
);

export const resolveMarkColor = (value) => {
  const raw = String(value || "").trim();
  if (/^#[0-9a-f]{6}$/i.test(raw)) return raw.toLowerCase();
  if (/^#[0-9a-f]{3}$/i.test(raw)) return expandShortHex(raw).toLowerCase();

  const normalizedName = raw.toLocaleLowerCase("de-DE");
  if (NAMED_MARK_COLORS[normalizedName]) return NAMED_MARK_COLORS[normalizedName];
  if (!raw) return "#be9e44";

  const hash = [...normalizedName].reduce(
    (total, character) => ((total * 31) + character.charCodeAt(0)) >>> 0,
    0
  );
  return FALLBACK_MARK_COLORS[hash % FALLBACK_MARK_COLORS.length];
};

export const getReadableMarkTextColor = (color) => {
  const resolved = resolveMarkColor(color);
  const red = parseInt(resolved.slice(1, 3), 16);
  const green = parseInt(resolved.slice(3, 5), 16);
  const blue = parseInt(resolved.slice(5, 7), 16);
  const brightness = (red * 299 + green * 587 + blue * 114) / 1000;
  return brightness >= 154 ? "#1a1a1a" : "#ffffff";
};

export const getMarkColorStyle = (value) => {
  if (!String(value || "").trim()) return undefined;
  const backgroundColor = resolveMarkColor(value);
  return {
    backgroundColor,
    color: getReadableMarkTextColor(backgroundColor),
  };
};

export const getMarkColorName = (value) => {
  const raw = String(value || "").trim();
  if (!raw) return "Ohne Farbe";

  const resolved = resolveMarkColor(raw);
  if (MARK_COLOR_NAMES[resolved]) return MARK_COLOR_NAMES[resolved];
  if (/^#[0-9a-f]{3,6}$/i.test(raw)) return "Eigene Farbe";
  return raw;
};

export const formatMarkColorLabel = (value) => {
  return String(value || "").trim() ? getMarkColorName(value) : "Farbe wählen";
};
